"use strict";
/**
 * @fileoverview Class Transform Proxy
 *
 * This module provides a conditional Type decorator that adapts to different environments:
 * - In webpack/frontend environments: Uses a no-op decorator to avoid importing backend dependencies
 * - In Node.js/backend environments: Uses the actual class-transformer Type decorator
 *
 * This allows shared interfaces to be used across both frontend and backend code without
 * breaking builds due to missing dependencies.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Type = void 0;
/**
 * No-op decorator factory that accepts any arguments and does nothing.
 *
 * @param {...any} _args - Arguments (unused, but needed for compatibility).
 * @returns {Function} A no-op property decorator.
 */
const noopDecorator = (..._args) => () => { };
/**
 * Logging error decorator factory that logs an error when class-transformer is missing.
 * This decorator emits a warning each time it's used, indicating that API documentation
 * won't be generated due to missing dependencies.
 *
 * @param {...any} _args - Arguments (unused, but needed for compatibility).
 * @returns {Function} A property decorator that logs an error.
 */
const loggingErrorDecorator = (..._args) => () => {
    console.error("class-transformer dependency missing! Type decorator not functioning.");
};
/**
 * Type decorator - conditionally uses real swagger decorator or no-op fallback.
 * Uses no-op when webpack is detected (frontend), otherwise imports from class-transformer.
 */
let Type;
exports.Type = Type;
// Check if webpack is being used (indicates frontend environment).
if (typeof __webpack_require__ !== "undefined") {
    // Frontend/webpack environment - use no-op.
    exports.Type = Type = noopDecorator;
}
else {
    try {
        // Backend/Node.js environment - use real clas-transformer decorator.
        const { Type: ClassTransformerType } = require("class-transformer");
        exports.Type = Type = ClassTransformerType;
    }
    catch {
        console.warn("ee-nestjs-interfaces is NOT recording Swagger API properties!");
        exports.Type = Type = loggingErrorDecorator;
    }
}
